import React from 'react';
import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
const PanelListItem = (props) => (React.createElement(LinkStyled, { to: props.to || '', className: props.className, style: props.style },
    React.createElement(PanelStyled, null, props.children)));
export default PanelListItem;
const PanelStyled = styled.div `
  padding: 10px 0px;
  transition: padding 0.2s;

  &:hover {
    padding: 10px 10px;
    background-color: #ddd;
  }
`;
const LinkStyled = styled(Link) `
  & > div {
    border-bottom: 1px solid lightgrey;
  }
  &:last-child {
    & > div {
      border-bottom: none;
    }
  }
`;
//# sourceMappingURL=PanelListItem.js.map